export const SessionIdKey = 'gsg_correlation_group'
